module.exports = [{
      plugin: require('/codebuild/output/src412661808/src/adamkinson/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/gatsby-icon.png"},
    },{
      plugin: require('/codebuild/output/src412661808/src/adamkinson/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
